import { useContext, useEffect, useState } from 'react';

import {
	BookOutlined,
	DeleteOutlined,
	EditOutlined,
	ReloadOutlined,
	SearchOutlined,
	UnorderedListOutlined,
} from '@ant-design/icons';
import {
	Button,
	Checkbox,
	Flex,
	Input,
	Popconfirm,
	Space,
	Spin,
	Table,
	Tabs,
	Tooltip,
	message,
} from 'antd';
import { useNavigate } from 'react-router-dom';

import { SubscriptionContext } from '@/App';
import {
	useDeleteSingleMonitor,
	useGetContentMonitors,
} from '@/api/monitor_collections';
import { SUBSCRIPTIONS_TYPES_ENUM } from '@/const';
import { useDebounce } from '@/hooks';
import hasSubscriptionType from '@/lib/helpers/hasSubscriptionType';
import { PageContext } from '@/providers/PageContextProvider';

import { IPagination } from '../video-intelligence-on-demand';
import AllQA from './AllQA';
import { columns } from './data';

export default function QuestionsAnswers() {
	const navigate = useNavigate();
	const { subscriptions, subscriptionLoading } =
		useContext(SubscriptionContext);
	const { setPageTitle, openDrawer, setIsCopilotCreditsCounterVisible } =
		useContext(PageContext);
	const [pagination, setPagination] = useState<IPagination>({
		page: 1,
		pageCount: 1,
		total: 0,
		limit: 10,
	});
	const [filterUserInsights, setFilterUserInsights] = useState(
		localStorage?.getItem('sv_show_user_insights') === '1' ? true : false,
	);

	const [search, setSearch] = useState('');
	const [sortBy, setSortBy] = useState<'created_at'>('created_at');
	const [sortOrder, setSortOrder] = useState<'desc' | 'asc'>('desc');

	const debouncedSearch = useDebounce(search);

	const { data, isLoading, isFetching, refetch } = useGetContentMonitors({
		page: pagination.page,
		limit: pagination.limit,
		sortBy,
		sortOrder,
		search: debouncedSearch.length >= 3 ? debouncedSearch : '',
	});

	const { mutate: deleteMonitor, isLoading: isDeleteMonitorLoading } =
		useDeleteSingleMonitor();

	const total = data?.data?.data?.total ?? 1;
	const items = data?.data?.data?.items ?? [];

	useEffect(() => {
		setPageTitle('Q&A Collections');
		setIsCopilotCreditsCounterVisible(true);

		return () => {
			setPageTitle('');
			setIsCopilotCreditsCounterVisible(false);
		};
	}, []);

	useEffect(() => {
		refetch();
	}, [filterUserInsights, sortOrder, pagination]);

	useEffect(() => {
		if (!subscriptionLoading && subscriptions && subscriptions?.length > 0) {
			if (
				!hasSubscriptionType(subscriptions, SUBSCRIPTIONS_TYPES_ENUM.copilot)
			) {
				navigate('/app/dashboard/product-main-menu');
			}
		} else if (
			!subscriptionLoading &&
			subscriptions &&
			subscriptions?.length === 0
		) {
			navigate('/app/dashboard/product-main-menu');
		}
	}, [subscriptions, subscriptionLoading]);

	const onTableChange = (__: any, _: any, sorter: any) => {
		const { field = 'created_at', order = 'ascend' } = sorter;

		if (field) {
			setSortBy(field);
			// setSearchParams((searchParams) => {
			// 	searchParams.set('sortBy', field);
			// 	return searchParams;
			// });
		}

		if (order) {
			setSortOrder(order === 'ascend' ? 'asc' : 'desc');
			// setSearchParams((searchParams) => {
			// 	searchParams.set('sortOrder', order === 'ascend' ? 'asc' : 'desc');
			// 	return searchParams;
			// });
		}
	};

	const onNewMonitorClick = () => {
		// setDrawer
		openDrawer('add-new-monitor');
	};

	const onDeleteClick = (id: number) => {
		deleteMonitor(id, {
			onSuccess: () => {
				message.success('Removed');
				// setSearch("");
			},
			onError: (error) => {
				const err = error as any;
				console.error('Error deleting collection:', err.response.data.message);
				message.error(err.response.data.message);
			},
		});
	};

	const onEditClick = (id: number) => {
		openDrawer('edit-monitor', {
			id,
		});
	};

	return (
		<Spin spinning={isLoading || isFetching}>
			<div>
				<Flex align="center" justify="space-between">
					<h2>Q&A Collections</h2>

					{/* <Space>
						<Tooltip title="Refresh" placement="left">
							<Button onClick={() => refetch()} icon={<ReloadOutlined />} />
						</Tooltip>

						<Tooltip title="Open drawer" placement="left">
							<Button onClick={() => openDrawer('qa-history')}>Open</Button>
						</Tooltip>
					</Space> */}
				</Flex>

				<Flex vertical gap={16} style={{ width: '100%' }}>
					<AllQA />
					{/* <Tabs
						items={[
							{
								key: 'all',
								label: 'All Q&A',
								children: (
									<Flex vertical gap={16} style={{ width: '100%' }}>
										<AllQA />
									</Flex>
								),
							},
							{
								key: 'reports',
								label: 'Reports',
								children: (
									<Flex vertical gap={16} style={{ width: '100%' }}>
										Reports
									</Flex>
								),
							},
						]}
					/> */}
				</Flex>
			</div>
		</Spin>
	);
}
